import { createSelector } from "reselect";

const getTickersData = (state) => state.tickers.data;
const getTickerEntities = (state) => state.entities.tickers;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const getTickers = (state) =>
    createSelector(getTickersData, getTickerEntities, (data, tickers) => {
        return data.map((tickerId) => tickers[tickerId]);
    })(state);
